import Vue from "vue";
import Vuex from "vuex";

import { alert } from "./alert.module";
import { authentication } from "./authentication.module";
import { users } from "./users.module";
import { aed } from "./aed.module";
import { aeds } from "./aeds.module";
import { tips } from "./tips.module";
import { tip } from "./tip.module";
import { translations } from "./translations.module";
import { manufacturers } from "./manufacturers.module";
import { availability } from "./availability.module";
import { owners } from "./owners.module";
import { loadingIndicator } from "./loadingIndicator.module";

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    translations: translations
  },
  modules: {
    alert,
    authentication,
    users,
    aed,
    aeds,
    translations,
    manufacturers,
    availability,
    owners,
    loadingIndicator,
    tips,
    tip
  }
});
